import React, { useEffect, useState } from 'react';
import { checkElement } from '@/components/SubSectionComponents/CleanFunctions.jsx';
import img from '@/assets/img/BallastImgs/firstMeterAndHalf/LEST_SH+PX+PX+RH_Maxi.svg';
import S from '@/styles/reactImgsBallast.module.css';
import InfoT from '@/pages/formwork/boxes/ConfiguratorStabilizier/ImageComponents/InfoT.jsx';
import InfoD from '@/pages/formwork/boxes/ConfiguratorStabilizier/ImageComponents/InfoD.jsx';
import InfoL from '@/pages/formwork/boxes/ConfiguratorStabilizier/ImageComponents/InfoL.jsx';
import ConfigStabilizeInfoButton from '@/pages/formwork/boxes/ConfiguratorStabilizier/ConfigStabilizeInfoButton.jsx';
import InfoB from '@/pages/formwork/boxes/ConfiguratorStabilizier/ImageComponents/InfoB.jsx';

function SHPxPxRhMax({ allHeightsPanel, T, D, L, B, fixTop }) {
  const [find, setFind] = useState(false);

  useEffect(() => {
    if (
      allHeightsPanel.length === 4 &&
      checkElement.firstMeterAndHalf([allHeightsPanel[0]]) &&
      checkElement.allPanels([allHeightsPanel[1]]) &&
      checkElement.allPanels([allHeightsPanel[2]]) &&
      checkElement.lastHalf([allHeightsPanel[3]]) &&
      fixTop
    ) {
      setFind(true);
    } else setFind(false);
  }, [allHeightsPanel, fixTop]);

  if (!find) {
    return null;
  }

  return (
    <div className={S.container}>
      <img className={S.containerImg} src={img} alt={'3m'} style={{ top: -61, left: 0 }} />

      <InfoT top={221} left={191} T={T} />
      <InfoD top={401} left={124} D={D} />
      <InfoL top={353} left={169} L={L} />
      <InfoB top={300} left={124} B={B} />

      <ConfigStabilizeInfoButton top={-108} />
    </div>
  );
}

export default SHPxPxRhMax;
